import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, Orbit } from "lucide-react";
import { siteData } from "../mock";

const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => setOpen(false), [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${
        scrolled
          ? "bg-[#05070d]/75 backdrop-blur-md border-b border-white/10 shadow-[0_10px_30px_-15px_rgba(59,130,246,0.35)]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto flex items-center justify-between px-5 md:px-8 py-4">
        <Link to="/" className="group flex items-center gap-2.5">
          <span className="relative w-9 h-9 rounded-full bg-gradient-to-br from-blue-500 via-indigo-500 to-purple-600 flex items-center justify-center shadow-[0_0_20px_-4px_rgba(99,102,241,0.7)]">
            <Orbit className="w-4 h-4 text-white group-hover:rotate-90 transition-transform duration-500" strokeWidth={2.2} />
            <span className="absolute inset-0 rounded-full border border-blue-300/40" />
          </span>
          <span className="font-bold tracking-tight text-lg text-white">
            com<span className="bg-gradient-to-r from-blue-400 to-indigo-400 bg-clip-text text-transparent">PLANET</span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {siteData.nav.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              className={({ isActive }) =>
                `relative text-sm font-medium transition-colors ${
                  isActive ? "text-white" : "text-white/70 hover:text-white"
                }`
              }
            >
              {({ isActive }) => (
                <>
                  {item.label}
                  {isActive && (
                    <span className="absolute -bottom-1.5 left-0 right-0 h-[2px] bg-gradient-to-r from-blue-400 to-indigo-400 rounded-full" />
                  )}
                </>
              )}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:block">
          <Link
            to="/contact"
            className="inline-flex items-center px-4 py-2 rounded-md bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-500 hover:to-indigo-500 text-white text-sm font-semibold transition-all shadow-[0_0_20px_-6px_rgba(99,102,241,0.8)] hover:-translate-y-0.5"
          >
            Get support
          </Link>
        </div>

        <button className="md:hidden p-2 text-white" onClick={() => setOpen(!open)} aria-label="Toggle menu">
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-[#0b1220]/95 backdrop-blur border-t border-white/10">
          <div className="px-5 py-4 flex flex-col gap-3">
            {siteData.nav.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `text-sm font-medium py-1 ${isActive ? "text-blue-400" : "text-white/85"}`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <Link to="/contact" className="mt-2 inline-flex justify-center px-4 py-2 rounded-md bg-gradient-to-r from-blue-600 to-indigo-600 text-white text-sm font-semibold">
              Get support
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
